// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upLoadPicBox[data-v-396d32d7] {\n  position: relative;\n}\n.upLoadPicBox .nick[data-v-396d32d7] {\n  width: 340px;\n  position: absolute;\n  left: 70px;\n  top: 15px;\n}\n[data-v-396d32d7] .el-dialog__body {\n  padding-top: 20px !important;\n}\n[data-v-396d32d7] .el-card__body {\n  padding: 0 0 20px !important;\n}", ""]);
// Exports
module.exports = exports;
